import * as T from 'prop-types';

import { Label, SelectFilter, Text } from '@olist/united';

export const SelectFilterField = ({ input, label, meta, options, placeholder }) => (
  <>
    <Label id={`select-${input.name}`}>
      <Text color={meta.error ? 'foundation.errorDefault' : 'foundation.shadeDarker'}>{label}</Text>
    </Label>
    <SelectFilter
      ariaLabelledBy={`select-${input.name}`}
      error={meta.error}
      placeholder={placeholder}
      options={options}
      {...input}
    />
    {meta.error && (
      <Text color="foundation.errorDefault" fontSize="14px" mt={[1]}>
        {meta.error}
      </Text>
    )}
  </>
);

SelectFilterField.propTypes = {
  input: T.shape({ name: T.string }).isRequired,
  label: T.string.isRequired,
  meta: T.shape({ error: T.bool }).isRequired,
  options: T.arrayOf(T.shape({})).isRequired,
  placeholder: T.string.isRequired,
};
